import { Component, OnInit, Input, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { GeneratedArtifact } from '../data/artifact';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { SpeechRecArtifact } from '../data/student-artifact';
import { FormatUtilities } from '../utilities/format-utilities';
import { DataService } from '../data/data.service';
import { BundledResponses, CreatorType } from '../data/daisychain';
import videojs from 'video.js';

@Component({
  selector: 'app-artifact-display',
  templateUrl: './artifact-display.component.html',
  styleUrls: ['./artifact-display.component.scss']
})
export class ArtifactDisplayComponent implements OnInit {
  constructor(private dataService: DataService, private sanitizer: DomSanitizer) { }

  @Input() artifact: GeneratedArtifact;
  static currentlyPlayingAudio: any;
  longDateFormat = FormatUtilities.longDateFormat;
  get loaded(): boolean { return !!this.artifact.Data; }

  bundledResponses: BundledResponses[];

  ngOnInit() {
    if (!this.artifact.Data) {
      this.dataService.getArtifact(this.artifact.StudentID, this.artifact.ArtifactID, this.artifact.StartedActivityID).subscribe(r2 => {
        this.artifact.Data = r2;
        this.handleDaisyChain();
      });
    }
    else {
      this.handleDaisyChain();
    }
    if (!(this.artifact.ActivityImageName[2] === "_")) this.artifact.ActivityImageName = "SS_"+ this.artifact.ActivityImageName;
  }

  playArtifactAudio(audioPlayer) {
    if (audioPlayer.paused) {
      if (ArtifactDisplayComponent.currentlyPlayingAudio) {
        ArtifactDisplayComponent.currentlyPlayingAudio.pause();
        ArtifactDisplayComponent.currentlyPlayingAudio.currentTime = 0;
      }
      ArtifactDisplayComponent.currentlyPlayingAudio = audioPlayer;
      audioPlayer.play()
    }
    else {
      audioPlayer.pause();
      audioPlayer.currentTime = 0;
    }
  }

  getArtifactBinary(): SafeResourceUrl {
    if (this.artifact.Data) {
      if (this.artifact.ArtifactType === 'colored_page') {
        var unsafeURL = URL.createObjectURL(new Blob([this.convertEncodedDataToBinary(this.artifact.Data)], { type: 'image/png' }));
      } else if (this.artifact.ArtifactType === 'song_recording') {
        var unsafeURL = URL.createObjectURL(new Blob([this.convertEncodedDataToBinary(this.artifact.Data)], { type: 'audio/mp3' }));
        console.log(unsafeURL)
      } else if (this.artifact.ArtifactType === 'speech_rec') {
        var speechRecData = new SpeechRecArtifact();
        speechRecData = this.artifact.Data as unknown as SpeechRecArtifact;
        if (speechRecData.Attempts)
          var binary = speechRecData.Attempts[0].Recording;
        var unsafeURL = URL.createObjectURL(new Blob([this.convertEncodedDataToBinary(binary)], { type: 'audio/mp3' }));
      }
      return this.sanitizer.bypassSecurityTrustResourceUrl(unsafeURL);
    }
  }

  convertEncodedDataToBinary(base64): Uint8Array {
    if (base64) {
      var raw = window.atob(base64);
      var rawLength = raw.length;
      var array = new Uint8Array(new ArrayBuffer(rawLength));
      for (var i = 0; i < rawLength; i++) {
        array[i] = raw.charCodeAt(i);
      }
    }
    return array;
  }

  handleDaisyChain(): void {
    if (this.artifact.ArtifactType !== 'daisy_chain_conversation_summary') return;
    this.bundledResponses = new Array();
    var currentBundled = new BundledResponses;
    currentBundled.BotResponses = new Array();

    this.artifact.Data.Responses.forEach(response => {
        if (response.CreatorType == CreatorType.Student) {
            currentBundled.StudentResponse = response;
            this.bundledResponses.push(currentBundled);
            currentBundled = new BundledResponses;
            currentBundled.BotResponses = new Array();
        } else {
            currentBundled.BotResponses.push(response);
        }
      });

    this.bundledResponses = this.bundledResponses.filter(x => x.BotResponses && x.BotResponses.length != 0);
  }
  playWasCalled(id: string) {
      var players = new Array();
      for (var x = 0; x < Object.keys(videojs.players).length; x++) {
          // Assign the player name to setPlayer
          var setPlayer = Object.keys(videojs.players)[x];
          players.push(setPlayer);
      }
      // Loop through the array of players
      for (var i = 0; i < players.length; i++) {
          // Get the player(s) that did not trigger the play event
          if (players[i] != id) {
              // Pause the other player(s)
              if (videojs.getPlayer(players[i])) videojs.getPlayer(players[i]).pause();
          }
      }
  }
}
